export const validateLogin = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  } else if (values.email.length > 250) {
    errors.email = "Email must be under 250 characters";
  }

  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password.length < 6) {
    errors.password = "Minimum 6 characters required";
  } else if (values.password.length > 20) {
    errors.password = "Maximum 20 characters allowed";
  }

  return errors;
};
export const validateProfile = (values) => {
  const errors = {};

  if (!values.fullname) {
    errors.fullname = "Full name is required";
  }

  return errors;
};
export const validateChangePassword = (values) => {
  const errors = {};

  if (!values.current_password) {
    errors.current_password = "Current password is required";
  }

  if (!values.new_password) {
    errors.new_password = "New password is required";
  } else if (values.new_password.length < 6) {
    errors.new_password = "Minimum 6 characters required";
  } else if (values.new_password.length > 20) {
    errors.new_password = "Maximum 20 characters allowed";
  }

  if (!values.confirm_password) {
    errors.confirm_password = "Confirm password is required";
  } else if (values.confirm_password !== values.new_password) {
    errors.confirm_password = "Passwords do not match";
  }

  return errors;
};
